import $ from "jquery";

//---------------------------------------------------------------------------------------------
// Description
// User interface helper module for the Service Request Log page
//---------------------------------------------------------------------------------------------
import { PagingHelper } from './paging_helper';
import { ServiceRequestLogCalendarHelper } from './service-request-log-calendar-helper';
export function ServiceRequestLogUI()
{
    const MODULE_FILENAME = "service-request-log-ui.js";
    const ITEMS_PER_PAGE = window.patternLibrary ? 3 : 6; // use 3 records per page while using pattern Library
    const TAB_OPEN = "open";
    const TAB_COMPLETED = "completed";

    var obj = {
        init: init,
        showPage: showPage,
        showAllPages: showAllPages,
        showUpToCurrentPage: showUpToCurrentPage,
        currentTab: TAB_OPEN,
        currentPageOpenRequests: 1,
        currentPageCompletedRequests: 1,
        noMorePages: false,
        onViewMoreButtonClick: onViewMoreButtonClick,
        onClickTab: onClickTab,
        saveState: saveState,
        restoreState: restoreState,
        openAllSRItems: openAllSRItems,
        openSRItems: openSRItems,
        closeSRItems: closeSRItems,
        uiState: {}
    };
    return obj;

    // Version 0.1 - assumes all UI elements are created,
    // this functionality simple shows and hides the pages of records
    function init()
    {
        var viewMoreButtonClass = '.msh-service-log_view-more-button';
        var openRecordClass = $("#open-requests").children(".msh-service-request-record");
        var completedRecordClass = $("#completed-requests").children(".msh-service-request-record");
        var bodyElement = $("body").addClass("service-request-print");
        var tabClass = '.tabs-title';
        obj.$viewMoreButton = $(viewMoreButtonClass);
        obj.$srOpen = $(openRecordClass);
        obj.$srCompleted = $(completedRecordClass);
        obj.$tabs = $(tabClass);

        initPrint();

        if (obj.$viewMoreButton)
        {
            obj.$viewMoreButton.each(function() {
                $(this).on('click', obj.onViewMoreButtonClick);
            });
        } else {
            console.error("View more button not found: " + viewMoreButtonClass);
        }

        if (obj.$tabs)
        {
            obj.$tabs.each(function() {
                $(this).on('click', obj.onClickTab);
            });
        } else {
            console.error("Tabs not found: " + tabClass);
        }        

        obj.pagerOpenRequests = PagingHelper();
        if (obj.$srOpen.length > 0)
        {
            obj.pagerOpenRequests.init(obj.$srOpen.length, ITEMS_PER_PAGE);
            var pageIndex = 1;
            obj.$srOpen.each(function() {
                $(this).addClass("is-hidden");
                $(this).attr("id", "sr-open-" + pageIndex);
                pageIndex++;
            });
        }
        obj.showPage(1,TAB_OPEN);
        obj.pagerCompletedRequests = PagingHelper();
        if (obj.$srCompleted.length > 0)
        {
            obj.pagerCompletedRequests.init(obj.$srCompleted.length, ITEMS_PER_PAGE);
            var pageIndex = 1;
            obj.$srCompleted.each(function() {
                $(this).addClass("is-hidden");
                $(this).attr("id", "sr-completed-" + pageIndex);
                pageIndex++;
            });
        }
        obj.showPage(1,TAB_COMPLETED);

        // Hide View More Button when there's only one page
        obj.$viewMoreButton.each(function() {
            var parent = $(this).parents(".tabs-panel");
            if (parent && parent.attr("id") == "open-requests") {
                if (obj.pagerOpenRequests.totalPages <= 1)
                {
                    $(this).addClass("is-hidden");
                }
            } else if (parent && parent.attr("id") == "completed-requests") {
                if (obj.pagerCompletedRequests.totalPages <= 1)
                {
                    $(this).addClass("is-hidden");
                }
            };                
        });

        var calendar = ServiceRequestLogCalendarHelper();
        calendar.init();
    }

    function initPrint()
    {
        obj.$printButtonOpen = $(".msh-service-log_results button")[0];
        obj.$printButtonCompleted = $(".msh-service-log_results button")[1];

        if (obj.$printButtonOpen) obj.$printButtonOpen.onclick = print;
        if (obj.$printButtonCompleted) obj.$printButtonCompleted.onclick = print;

        function print()
        {
            obj.saveState();
            obj.openSRItems([],true);
            obj.showAllPages();
            setTimeout(function()
            {
                window.print();
                obj.restoreState();
            }, 1000);
        }
    }

    function onViewMoreButtonClick()
    {
        var currentPage = obj.currentTab == TAB_OPEN ? obj.currentPageOpenRequests : obj.currentPageCompletedRequests;
        var pager = obj.currentTab == TAB_OPEN ? obj.pagerOpenRequests : obj.pagerCompletedRequests;

        if (obj.currentTab == TAB_OPEN)
        {
            obj.currentPageOpenRequests++;
            obj.showPage(obj.currentPageOpenRequests);
        } else {
            obj.currentPageCompletedRequests++;
            obj.showPage(obj.currentPageCompletedRequests);
        }

        currentPage = obj.currentTab == TAB_OPEN ? obj.currentPageOpenRequests : obj.currentPageCompletedRequests;
        if (currentPage >= pager.totalPages)
        {
            obj.noMorePages = true;
            obj.$viewMoreButton.each(function() {
                $(this).addClass("is-hidden");
            });            
        }
    }

    function onClickTab(tab)
    {
        try
        {
            var id = tab.target.getAttribute("id");
            var idChild = (tab.target.children && tab.target.children.length > 0) ? tab.target.children[0].getAttribute("id") : "";
            if (id == "open-requests-label" || idChild == "open-requests-label")
            {
                obj.currentTab = TAB_OPEN;
            }
            else if (id == "completed-requests-label" || idChild == "completed-requests-label")
            {
                obj.currentTab = TAB_COMPLETED;
            }
        }
        catch (err)
        {
            console.error("Module: " + MODULE_FILENAME + " - onClickTab error occurred");
        }
    }

    function showUpToCurrentPage()
    {
        var indicies = obj.currentTab == TAB_OPEN ? obj.pagerOpenRequests.getPages(obj.currentPageOpenRequests) : obj.pagerCompletedRequests.getPages(obj.currentPageCompletedRequests);
        var lastIndexShown = indicies[indicies.length-1];
        var totalRecords = obj.currentTab == TAB_OPEN ? obj.pagerOpenRequests.totalRecords : obj.pagerCompletedRequests.totalRecords;
        var type = obj.currentTab;      
        var index = 1;
        while (index <= totalRecords && totalRecords > 0)
        {
            var el = document.getElementById("sr-" + type + "-" + index);
            if (el) 
            {
                if (index <= lastIndexShown)
                {
                    el.classList.add("is-visible");
                    el.classList.remove("is-hidden");
                }
                else
                {
                    el.classList.remove("is-visible");
                    el.classList.add("is-hidden");
                }
            }
            index++;
        }
    }

    function showPage(pageNumber, tab)
    {
        var type = !tab ? obj.currentTab : tab;
        if (!pageNumber) pageNumber = obj.currentTab == TAB_OPEN ? obj.currentPageOpenRequests : obj.currentPageCompletedRequests;
        var indicies = type == "open" ? obj.pagerOpenRequests.getPages(pageNumber) : obj.pagerCompletedRequests.getPages(pageNumber);
        if (indicies && indicies.length > 0)
        {
            indicies.forEach(index => {
                var el = document.getElementById("sr-" + type + "-" + index);
                if (el) 
                {
                    el.classList.add("is-visible");
                    el.classList.remove("is-hidden");
                }
            });
        }
    }

    function showAllPages()
    {
        var type = obj.currentTab;
        var totalRecords = obj.currentTab == TAB_OPEN ? obj.pagerOpenRequests.totalRecords : obj.pagerCompletedRequests.totalRecords;
        var index = 1;
        while (index <= totalRecords && totalRecords > 0)
        {
            var el = document.getElementById("sr-" + type + "-" + index);
            if (el) 
            {
                el.classList.add("is-visible");
                el.classList.remove("is-hidden");
            }
            index++;
        }
    }

    //---------------------------------------------------------------------------------------------
    // Saves the Service Request pages shown and view item open states.
    // Restore allows the state to be restored.
    //---------------------------------------------------------------------------------------------
    function saveState()
    {
        var tab = obj.currentTab == TAB_OPEN ? TAB_OPEN : TAB_COMPLETED;
        var pageNumber = tab == TAB_OPEN ? obj.currentPageOpenRequests : obj.currentPageCompletedRequests;
        obj.uiState[tab] = {
            pageNumber: pageNumber,
            openServiceRequestIDs: []
        }

        $(".msh-service-log_accordion-item.is-active").each(function()
        {
            var idParent = $(this).parents(".msh-service-request-record").attr("id");
            obj.uiState[tab].openServiceRequestIDs.push(idParent);
        })
    }

    function restoreState()
    {
        var tab = obj.currentTab == TAB_OPEN ? TAB_OPEN : TAB_COMPLETED;
        if (obj.uiState[tab])
        {
            openSRItems(obj.uiState[tab].openServiceRequestIDs); // only includes the open IDs
            closeSRItems(obj.uiState[tab].openServiceRequestIDs); // excludes the open IDs
        }
        obj.showUpToCurrentPage();
    }

    function openAllSRItems(includeSRIds)
    {
        obj.openSRItems([], true);
    }
    
    function openSRItems(includeSRIds, includeAll)
    {
        var tab = obj.currentTab == TAB_OPEN ? TAB_OPEN : TAB_COMPLETED;
        if (!includeSRIds) includeSRIds = [];
        $(".msh-service-log_accordion ul").each(function()
        {
            var $ulAccordian = $(this);
            var srId = $ulAccordian.parent().parent().attr("id");
            if (srId && srId.indexOf(tab) >= 0)
            {
                if (includeSRIds.includes(srId) || includeAll)
                {
                    var children = $(this).children();
                    children.each(function(){
                        // open the item
                        $ulAccordian.foundation("down", $(this).children());
                    })
                }
            }
        });
    }

    function closeSRItems(excludeSRIds)
    {
        var tab = obj.currentTab == TAB_OPEN ? TAB_OPEN : TAB_COMPLETED;
        if (!excludeSRIds) excludeSRIds = [];
        $(".msh-service-log_accordion ul").each(function()
        {
            var $ulAccordian = $(this);
            var srId = $ulAccordian.parent().parent().attr("id");
            if (srId && srId.indexOf(tab) >= 0)
            {
                if (!excludeSRIds.includes(srId))
                {
                    var children = $(this).children();
                    children.each(function(){
                        // collapses the item
                        $ulAccordian.foundation("down", $(this).children("li"));
                    })
                }
            }
        });
    }
};

//-------------------------------------------------------------------------------------------------
// Service Request Loaded
//-------------------------------------------------------------------------------------------------
$(document).ready(function ()
{
    if ($('.msh-service-log').length) {
        ServiceRequestLogUI().init();
    }
});
